import React from 'react';

export default function SortableHeaderCellComp(props){
    return(
        <th onClick={() => props.onClick(props.value)}>
            {props.children}

            {props.value === props.sortBy &&
      <i className={props.sortAscending ? 'fas fa-arrow-down' : 'fas fa-arrow-up'} />
            }
        </th>
    );
}
